import type { ShipmentAddressSectionKey } from '../models/address-form.model';

export type UnserviceableAddressSectionKey = ShipmentAddressSectionKey;

/**
 * Resolves which address sections should show unserviceable errors from the API message.
 * Mirrors backend {@link mapEsdServiceAbilityResponse} user-facing labels.
 */
export function resolveUnserviceableAddressSections(
  message: string,
): UnserviceableAddressSectionKey[] {
  const normalized = message.trim().toLowerCase();

  if (normalized.includes('both origin and destination')) {
    return ['shipFrom', 'shipTo'];
  }

  const sections: UnserviceableAddressSectionKey[] = [];

  if (normalized.includes('origin')) {
    sections.push('shipFrom');
  }

  if (normalized.includes('destination')) {
    sections.push('shipTo');
  }

  if (normalized.includes('return')) {
    sections.push('returnAddress');
  }

  if (sections.length > 0) {
    return sections;
  }

  return ['shipTo'];
}
